import type { SlateLeaf } from '@atlas/renderer';
import extractNodeTextRecursively from '@atlas/tool/box/slate/extractNodeTextRecursively';

export default function extractLeavesFromHtml(html: string): SlateLeaf[] {
    if (!html.trim()) return [{ text: '' }];

    const node = Object.assign(document.createElement('p'), { innerHTML: html });

    return extractNodeTextRecursively(node.childNodes);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('extractLeavesFromHtml', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
